import { memo, useCallback } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from 'src/components/buttons';
import { RequireLoginButton } from '../RequireLoginButton';
import { likeSelector } from 'src/selectors/user';
import * as UserAction from 'src/redux/actions/user/dispatchActions';

interface IProps {
    className?: string;
    contentId: number;
    text?: string;
    classNameIcon?: string;
    classIconLike?: string;
    icon?: string;
    iconLike?: string;
}

const LikeButton = ({
    className,
    contentId,
    classNameIcon,
    classIconLike,
    icon = 'new-thumb-regular',
    iconLike = 'new-thumb-solid',
}: IProps) => {
    const likes = useSelector(likeSelector);
    const isLike = likes.indexOf(contentId) > -1;
    const dispatch = useDispatch();
    const handleClick = useCallback(() => {
        if (!isLike) {
            dispatch(UserAction.like(contentId));
        }
    }, [isLike, contentId]);

    return (
        <RequireLoginButton onClickFn={handleClick}>
            <IconButton
                renderAs="button"
                text={isLike ? 'Bài viết đã được thích' : 'Thích bài viết'}
                className={cn('btn-like', className)}
                classNameIcon={isLike ? classIconLike : classNameIcon}
                icon={isLike ? iconLike : icon}
            ></IconButton>
        </RequireLoginButton>
    );
};

export default memo(LikeButton);
